class Vacancy {

    constructor() {
        let vacancyData = $('.js-vacancy-data').data('source'),
            $hero = $('.vacancy-promo__bg-hero');

        if (vacancyData) {
            if (vacancyData.style) {
                $('.vacancy-promo__bg').css({
                    'background-color': vacancyData.style['background-color'],
                    'fill': vacancyData.style['fill']
                });
            }
            if (vacancyData.image) {
                $hero.html('<img class="_animated" src="' + vacancyData.image + '" alt="">');
                requestAnimationFrame(function () {
                    $hero.find('._animated').removeClass('_animated');
                });
            }
            if (vacancyData.form) {
                for (let key in vacancyData.form) {
                    $('[name="' + key + '"]').val(vacancyData.form[key]);
                }
            }
        }
    }
}

let vacancy = new Vacancy();

export default vacancy;
